import { render, staticRenderFns } from "./ProjectsCustomKanban.vue?vue&type=template&id=2b1d508c&scoped=true&"
import script from "./ProjectsCustomKanban.vue?vue&type=script&lang=js&"
export * from "./ProjectsCustomKanban.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsCustomKanban.vue?vue&type=style&index=0&id=2b1d508c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1d508c",
  null
  
)

export default component.exports